import * as React from "react";

import { cn } from "../../lib/utils";
import { Spinner, type SpinnerProps } from "./spinner";

export interface PageLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  size?: SpinnerProps["size"];
  fullScreen?: boolean;
  fadeIn?: boolean;
}

const PageLoader = React.forwardRef<HTMLDivElement, PageLoaderProps>(
  (
    { className, label, size = "lg", fullScreen = false, fadeIn = true, ...props },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center gap-4",
          fullScreen ? "h-screen" : "h-full min-h-[200px]",
          fadeIn && "animate-in fade-in duration-300",
          className
        )}
        {...props}
      >
        <Spinner size={size} />
        {label && (
          <p className="text-sm text-muted-foreground animate-pulse">{label}</p>
        )}
      </div>
    );
  }
);
PageLoader.displayName = "PageLoader";

export { PageLoader };
